// extracted by mini-css-extract-plugin
module.exports = {"marketBannerAdv":"index_marketBannerAdv_31Kwp","bannerBox":"index_bannerBox_2Yqkh","image":"index_image_32vHa"};